export default "__VITE_PUBLIC_ASSET__97854869__"